import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { callAPI, IsSmallScreen, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import http from "../../../commonFunctions/httpClient";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from '../../../commonFunctions/PermissionManger';
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";

export const BranchList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getLeadPermission;
  const [leadListData, setLeadlistData] = useState<any>([])
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const isMobile = IsSmallScreen();
  const [rowId, setRowId] = useState<any>(null);
  const location = useLocation();
  const { status } = location.state || {};

  const {
    open,
    title,
    onConfirm,
    handleClose,
    openConfirmDialog,
  } = useConfirmDialog();
  useEffect(() => {
    updateMainHeader('Leads');

    breadCrumbsStore.updateBreadCrumbs([
      { "Branch": "" },
    ]);
  });


  const source = {
    url: "Branch/search",
    page: 1,
    pageSize: 10,
    filter: [

    ],
    sort: [
      //   {
      //     field: "UptedAt", // maybe typo? was "UptedAt"
      //     direction: "desc"
      //   }
    ],
  };
  const handleDelete = async (id?: string | number) => {
    const response: any = await callAPI(`Branch`, Method.DELETE, null, id);
    dispatch(resetDataComponent('branchGrid'));
    if (response?.success) {
      showMessage(response?.message, "success")
    }
    else {
      showMessage(response?.message || 'Something went wrong', "error")
    }
    handleClose()

  };

  /**
   * Edit function
   * @param action 
   * @param row 
   */
  const handleAction = async (action: string, row: any) => {

    if (action === "Edit") {
      navigate(`/branch/edit/${row?.id}`)
    }
    else if (action === 'Delete') {
      openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
    }

  };

  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "name",
      type: "default",
    },
    {
      header: "Email",
      fieldName: "email",
      type: "default",
      //  sortable: true
    },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,
      type: "default",
    },
    {
      header: "Code",
      fieldName: "branchCode",
      isHide: isMobile,
      type: "default",
    },
    // {
    //   header: "Address",
    //   fieldName: "address",
    //   tooltip: true,
    //   type: "default"
    // },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, 'Delete'].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },

  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Name",
      fieldName: "name",
      type: "default",
    },
    {
      header: "Email",
      fieldName: "email",
      type: "default",
      //  sortable: true
    },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,
      type: "default",
    },
    {
      header: "Code",
      fieldName: "branchCode",

      type: "default",
    },
    {
      header: "Address",
      fieldName: "address",
      tooltip: true,
      type: "default"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined,].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },

  ];

  const handleClick = () => {
    navigate('/branch/create')
  }

  return (
    <>
      {/* <RazorpayCheckout /> */}
      <Grid container spacing={2}>
        {view ?
          <Grid item xs={12}>
            {!isMobile && <WSDataGrid
              id="branchGrid"
              title="Branch"
              columns={columns}
              source={source}
              addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
            />
            }
            {isMobile &&
              <WSMobileDataGridAdvanced title={'Leads'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                onAddButtonClick={handleClick} columns={mobColumns} id="branchGrid" source={source} />
            }
          </Grid>
          : <PermissionDenied />
        }
      </Grid>
      <ConfirmDialog
        open={open}
        title={title}
        onConfirm={onConfirm}
        onClose={handleClose}
      />
    </>
  )
})